import { Capacitor } from '@capacitor/core'
import { SafeArea } from 'capacitor-plugin-safe-area'

if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
  SafeArea.getStatusBarHeight().then(({ statusBarHeight }) => {
    document.documentElement.style.setProperty(
      `--safe-area-statusbarHeight`,
      `${statusBarHeight}px`,
    )
  })

  SafeArea.addListener('safeAreaChanged', (data) => {
    const { insets } = data
    for (const [key, value] of Object.entries(insets)) {
      document.documentElement.style.setProperty(`--safe-area-${key}`, `${value}px`)
    }
  })
}
